import React from "react";
import IMG1 from '../../assets/1.png'
const HeaderSection = (props) =>{
    return (
        <>
        {
            props.name === "Shop" ?
            <section
                id="frist_header_all_page"
                style={{
                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.3)), url('https://i.pinimg.com/originals/49/16/ba/4916baf0575b121dac9bb85e23f80c21.jpg')`,
                    backgroundSize:"cover",
                    backgroundRepeat:"no-repeat",
                }}
        >
            <p id="name_header_title">{props.name}</p>
        </section>
        :
        <section
        id="frist_header_all_page"
        style={{
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${IMG1})`,
            backgroundSize:"cover",
            backgroundRepeat:"no-repeat",
        }}
        >
            <p id="name_header_title">{props.name}</p>
        </section>
        }
            
        </>
        
    )
}
export default HeaderSection;